<template>
  <div class="progress">
    <p>此功能仅在桌面客户端可用</p>
  </div>
</template>
<script>
export default {
  name: "Update",
};
</script>
<style lang="less" scoped>
.progress {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
